// 242 PART B / 241 — the ONE definition of the sanity AREA taxonomy (the business areas the user works
// in), shared by ModuleAlert (per-module page alerts, 241) and SanityReportPage (area filter pills +
// grouping, 242B). Each area rolls up one or more rule families (A-M). Family-level is COARSE — some
// areas span several families; a rule-level override map is the later refinement. `pages` = the
// currentPage keys where a module page carries the alert (used by ModuleAlert only).
//
// K -> Procurement (K8 "Stale En-Route Purchases" is procurement work — point where the FIX lives).
// Heavy bucket: Finance = A/F/L = 28 of 63 rules — a candidate for later sub-splitting via the
// rule-level override map (flagged, not fixed here).
export const AREAS = [
  { label: 'Finance',       families: ['A', 'F', 'L'], pages: ['general-journal', 'payment-management'] },
  { label: 'Inventory',     families: ['B', 'E'],       pages: ['data-entry', 'reports'] },
  { label: 'Review & Post', families: ['C'],            pages: ['review'] },
  { label: 'Bands',         families: ['D', 'M'],       pages: ['bands-d', 'bands-list', 'band-detail', 'farms-list', 'farm-detail'] },
  { label: 'Settings',      families: ['G', 'I', 'J'],  pages: ['settings'] },
  { label: 'Re-Allocation', families: ['H'],            pages: ['reallocation'] },
  { label: 'Procurement',   families: ['K'],            pages: ['procurement'] },
];

// 244 — rule-level AREA overrides. The family->area default is 1:1, but some checks genuinely span
// MORE THAN ONE business area; list them here (rule id -> ordered area labels). This is the ONE place
// multi-area lives — the row badges and the area filter both read areasForRule(). It is a STARTING,
// owner-curatable set: extend/trim as the desk's mental model dictates (labels must match AREAS above).
export const RULE_AREAS = {
  A4: ['Finance', 'Inventory'],      // inventory tie-out reconciles the finance ledger against physical stock
  A6: ['Finance', 'Inventory'],      // inventory node-attribution — finance legs mapped to stock nodes
  'EGG-2': ['Inventory'],            // E13 vs delivered sales/E3 egg quantity tie: an inventory check though family F
  K8: ['Procurement', 'Inventory'],  // stale en-route = procurement follow-up AND in-transit stock
};

export const areaForPage   = (page) => AREAS.find(a => a.pages.includes(page)) || null;
export const areaForFamily = (fam)  => AREAS.find(a => a.families.includes(fam)) || null;

// 244 — the business area(s) a rule belongs to: its explicit override if present, else the single area
// of its family. Always an array (0..N labels). Grouping stays by family; this only drives the row
// badges + the area filter (a rule matches the filter if ANY of its areas is selected).
export const areasForRule = (rule) => {
  if (!rule) return [];
  const o = RULE_AREAS[rule.id];
  if (o && o.length) return o;
  const a = areaForFamily(rule.family);
  return a ? [a.label] : [];
};
